export default "__VITE_ASSET__c8260d1a__"